import classNames from 'classnames';
import React from 'react';
import { useEffect } from 'react';
import { useMemo } from 'react';
import { useState } from 'react';
import zxcvbn from 'zxcvbn';
import s from './PasswordStrengthBar.module.scss';

const PasswordStrengthBar = ({ password }) => {
  const score = useMemo(() => zxcvbn(password).score, [password]);
  const [strength, setStrength] = useState('strong');
  const strengthDisplay = useMemo(() => strength.replace('-', ' '), [strength]);

  useEffect(() => {
    switch (score) {
      case 1:
        setStrength('very-weak');
        break;
      case 2:
        setStrength('weak');
        break;
      case 3:
        setStrength('good');
        break;
      case 4:
        setStrength('strong');
        break;
      default:
        break;
    }
  }, [score]);

  const firstBar = useMemo(() => strength, [strength]);
  const secondBar = useMemo(() => (strength !== 'very-weak' ? strength : ''), [strength]);
  const thirdBar = useMemo(
    () => (strength !== 'weak' && strength !== 'very-weak' ? strength : ''),
    [strength]
  );
  const fourthBar = useMemo(() => (strength === 'strong' ? strength : ''), [strength]);
  return (
    <div className={s['strength-container']}>
      <div className={s['strength-bar']}>
        <div className={classNames(s['bar'], s[firstBar])}></div>
        <div className={classNames(s['bar'], s[secondBar])}></div>
        <div className={classNames(s['bar'], s[thirdBar])}></div>
        <div className={classNames(s['bar'], s[fourthBar])}></div>
      </div>
      <span className={s['text']}>{strengthDisplay}</span>
    </div>
  );
};

export default PasswordStrengthBar;
